
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"78","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.574 1.113L1.74 12.658l36.285 14.853 36.296-14.303L38.574 1.113z","stroke":"#333","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M63.05 17.887v17.314s-8.884-3.497-24.55-3.497h.159c-15.666-.042-24.518 3.497-24.518 3.497V17.887","stroke":"#333","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M38.437 10.63l35.884 2.578v14.366M76.74 32.032c0 2.672-1.933 6.855-2.82 6.855-.888 0-2.42-3.77-2.42-6.443 0-2.673 1.522-4.036 2.42-4.036.897 0 2.82.93 2.82 3.624z","stroke":"#333","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    